import { sendGetRequest, sendPostRequest } from './common.js';
const END_POINT = 'https://search.visenze.com';
const CN_END_POINT = 'https://search.visenze.com.cn';
const PATH_SEARCH = 'v1/product/search_by_image';
const PATH_REC = 'v1/product/recommendations';
const PATH_MULTISEARCH = 'v1/product/multisearch';
const PATH_MULTISEARCH_AUTOCOMPLETE = 'v1/product/multisearch/autocomplete';
function getAnalyticsParams(queryParams, vaParams) {
    const params = {};
    if (vaParams) {
        params['va_uid'] = vaParams['uid'];
        params['va_sdk'] = vaParams['sdk'];
        params['va_sdk_version'] = vaParams['v'];
        // search sid will take prority over analytics sid
        params['va_sid'] = (queryParams === null || queryParams === void 0 ? void 0 : queryParams['va_sid']) || vaParams['sid'];
        // search uid will take prority over analytics uid
        params['va_uid'] = (queryParams === null || queryParams === void 0 ? void 0 : queryParams['va_uid']) || vaParams['uid'];
    }
    return params;
}
function getAuthParams(settings) {
    const params = {
        app_key: settings['app_key'],
        placement_id: settings['placement_id'],
    };
    if (!settings['placement_id'] && settings['strategy_id']) {
        params['strategy_id'] = settings['strategy_id'];
    }
    return params;
}
function getEndpoint(settings) {
    if (settings.endpoint) {
        return settings.endpoint;
    }
    return settings['is_cn'] ? CN_END_POINT : END_POINT;
}
function getQueryParams(params, vaParams, settings) {
    return Object.assign(Object.assign(Object.assign({}, (params !== null && params !== void 0 ? params : {})), getAnalyticsParams(params, vaParams)), getAuthParams(settings));
}
function multisearch(settings, params, vaParams, callback, failure) {
    const queryParams = getQueryParams(params, vaParams, settings);
    return sendPostRequest(settings, getEndpoint(settings), PATH_MULTISEARCH, queryParams, callback, failure);
}
function multisearchAutocomplete(settings, params, vaParams, callback, failure) {
    const queryParams = getQueryParams(params, vaParams, settings);
    return sendPostRequest(settings, getEndpoint(settings), PATH_MULTISEARCH_AUTOCOMPLETE, queryParams, callback, failure);
}
function searchByImage(settings, params, vaParams, callback, failure) {
    const queryParams = getQueryParams(params, vaParams, settings);
    return sendPostRequest(settings, getEndpoint(settings), PATH_SEARCH, queryParams, callback, failure);
}
function searchById(settings, productId, params, vaParams, callback, failure) {
    const queryParams = getQueryParams(params, vaParams, settings);
    return sendGetRequest(settings, getEndpoint(settings), `${PATH_REC}/${productId}`, queryParams, callback, failure);
}
function searchByIdByPost(settings, productId, params, vaParams, callback, failure) {
    const queryParams = getQueryParams(params, vaParams, settings);
    return sendPostRequest(settings, getEndpoint(settings), `${PATH_REC}/${productId}`, queryParams, callback, failure);
}
export { searchById, searchByImage, searchByIdByPost, multisearch, multisearchAutocomplete };
